var map = {
	"./development": [
		4834,
		834
	],
	"./development.ts": [
		4834,
		834
	],
	"./production": [
		2922,
		922
	],
	"./production.ts": [
		2922,
		922
	],
	"./staging": [
		87,
		87
	],
	"./staging.ts": [
		87,
		87
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 327;
module.exports = webpackAsyncContext;